import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewAlbor = () => import('./Index')

const router = [
    {
        path: '/',
        component: DefaultContainer,
        children: [
            {
                path: 'integraciones/albor',
                name: 'Albor',
                component: ViewAlbor,
                beforeEnter: Permisos.IS_AUTENTICADO,
            },
        ],
    },
]

export default router